import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

import { ConfirmedModel } from './confirmed.model';
import { State } from '../../reducers/index';
import { HIDE_HEADER } from '../../actions/header.action';
import { INFO_UPDATE } from '../../actions/info.action';
import { Booking } from '../../actions/booking.action';

@Component({
  selector: 'consentz-confirmed',
  templateUrl: './confirmed.template.html',
  styleUrls: ['./confirmed.style.scss']
})
export class ConfirmedComponent implements OnInit {
  public model: ConfirmedModel = new ConfirmedModel(
    JSON.parse(localStorage.getItem('currentBookingOptions')),
    localStorage.getItem('AppId') ? localStorage.getItem('AppId') : window.location.hash.split('/')[1],
    JSON.parse(localStorage.getItem('currentUser')).user
  );
  public booking$: any = null;

  constructor(private store: Store<State>) {
    // hide header, subscribtion for widget options
    this.store.dispatch({ type: HIDE_HEADER });
    this.booking$ = store.select<any>('booking').subscribe((data: Booking) => {
      if (data['widget']) {
        this.model.currentBookingOptions = data;
      }
    });
  }
  // unsubscribe from store
  public ngOnInit(): void {
    this.booking$.unsubscribe();
    this.store.dispatch({
      type: INFO_UPDATE,
      payload: {
        clinic: null,
        treatment: null,
        price: null,
        practitioner: null,
        date: null,
        dateBusy: null,
        customer: null,
        token: null,
        data: null,
        time: null,
        type: null,
        details: null
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/components/confirmed/confirmed.component.ts